export default __webpack_public_path__ + "static/media/child-profile-created.ffd7d713.png";